"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerRadioInputElement = exports.renderRadioInputItem = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _inputFieldRenderer = require("../../../../core/render/items/input-engine/input-field-renderer");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-radio-input-field .info=", "></bm-radio-input-field> "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<label>\n\t\t\t\t\t\t<input type=\"radio\"\n\t\t\t\t\t\t\t\tname=\"", "\"\n\t\t\t\t\t\t\t\tid=\"", "\"\n\t\t\t\t\t\t\t\tclass=\"", "\"\n\t\t\t\t\t\t\t\tvalue=\"", "\"\n\t\t\t\t\t\t\t\t?disabled=", "\n\t\t\t\t\t\t\t\t?checked=", "\n\t\t\t\t\t\t\t\tdata-qe-id=\"", "\"\n\t\t\t\t\t\t\t\t@change=", "\n\t\t\t\t\t\t\t\t@blur=", ">\n\t\t\t\t\t\t\t\t<span class=\"styled-radio\"\n\t\t\t\t\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t\t\t\t\taria-role=\"radio\"\n\t\t\t\t\t\t\t\t\taria-checked=\"", "\"\n\t\t\t\t\t\t\t\t\t@keypress=", ">\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t", "\n\t\t\t\t</label>\n\t\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\tinput {\n\t\tborder: 0;\n\t\theight: 1px;\n\t\tmargin: -1px;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\tdisplay: none;\n\t\twidth: 1px;\n\t}\n\tlabel {\n\t\tdisplay: inline-block;\n\t\tline-height: 1.5em;\n\t\tpadding-left: 2.2em;\n\t\ttext-indent: -2.2em;\n\t\tmargin-bottom: 0.5em;\n\t}\n\tinput + span:before {\n\t\tcontent: '';\n\t\tdisplay: inline-block;\n\t\tmargin-right: 0.8em;\n\t\twidth: 0.7em;\n\t\theight: 0.7em;\n\t\tvertical-align: -0.2em;\n\t\tborder-radius: 0.6em;\n\t\tborder: 0.18em solid #ffffff;\n\t\tbackground-color: #ffffff;\n\t\tbox-shadow: 0 0 0 0.1em rgb(178, 178, 184);\n\t\ttransition: 0.3s ease all;\n\t}\n\tinput:checked + span:before {\n\t\tbackground: var(--accent-color);\n\t}\n\tinput:disabled + span:before {\n\t\tborder-color: rgb(244, 245, 247);\n\t\tbackground-color: rgb(244, 245, 247);\n\t}\n\tinput:disabled:checked + span:before {\n\t\tbackground: #cccccc;\n\t}\n\tinput:disabled + span {\n\t\tcolor: #999999;\n\t}\n\tspan:focus {\n\t\toutline: none;\n\t}\n\tspan:focus:before {\n\t\tbox-shadow: 0 0 0 0.1em rgb(55, 56, 61);\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var radioStyle = (0, _element.css)(_templateObject());

var BmRadioInputFieldElement = /*#__PURE__*/function (_BmInputFieldElement) {
  (0, _inherits2.default)(BmRadioInputFieldElement, _BmInputFieldElement);

  var _super = (0, _createSuper2.default)(BmRadioInputFieldElement);

  function BmRadioInputFieldElement() {
    (0, _classCallCheck2.default)(this, BmRadioInputFieldElement);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmRadioInputFieldElement, [{
    key: "_renderInput",
    value: function _renderInput() {
      var _context,
          _this = this;

      var items = (0, _map.default)(_context = this.info.options.items || []).call(_context, function (o) {
        return o.value ? o : {
          name: o,
          value: o
        };
      });
      return this.html(_templateObject2(), (0, _repeatInstanceProperty(_element))(items, function (option) {
        return _this._renderRadio(option);
      }));
    }
  }, {
    key: "_renderRadio",
    value: function _renderRadio(item) {
      var _context2, _context3;

      var id = (0, _concat.default)(_context2 = "".concat(this.info.name, "-")).call(_context2, item.value);
      var qeId = this.info.options.dataQeId ? (0, _concat.default)(_context3 = "".concat(this.info.options.dataQeId, "-")).call(_context3, item.value) : undefined;
      return this.html(_templateObject3(), this.info.name, id, (0, _element.classMap)({
        'bm-readonly': this.readonly
      }), item.value, this.info.disabled || this.readonly, this.info.value === item.value, (0, _element.ifDefined)(qeId), this._handleFormEvent, this._handleFormEvent, this.info.value === item.value, this._handleKeyPress, item.name);
    }
  }, {
    key: "_handleKeyPress",
    value: function _handleKeyPress(evt) {
      if (!this.info.disabled && evt.keyCode === 32) {
        evt.target.click();
      }
    }
  }, {
    key: "_handleFormEvent",
    value: function _handleFormEvent(evt) {
      if (evt.type === 'blur') {
        if (!this.info.touched) {
          this.dispatchBmFormEvent({
            type: 'touched'
          });
        }
      } else if (evt.type === 'change') {
        this.dispatchBmFormEvent({
          type: 'changed',
          data: {
            currentValue: evt.target.value,
            previousValue: this.value
          }
        });
      }
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-radio-input-field';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [radioStyle];
    }
  }]);
  return BmRadioInputFieldElement;
}(_inputFieldRenderer.BmInputFieldElement);

var renderRadioInputItem = function renderRadioInputItem(info) {
  return (0, _element.html)(_templateObject4(), info);
};

exports.renderRadioInputItem = renderRadioInputItem;

var registerRadioInputElement = function registerRadioInputElement() {
  (0, _element.register)(BmRadioInputFieldElement);
};

exports.registerRadioInputElement = registerRadioInputElement;
